import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead, SITE_URL } from "@/components/SEO";

export const Route = createFileRoute("/contact")({
  head: () =>
    buildHead({
      path: "/contact",
      breadcrumbs: [
        { name: "Home", url: SITE_URL },
        { name: "Contact", url: `${SITE_URL}/contact` },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/Contact")),
});
